export default {
  sections: {
    address: 'Adresă firmă',
    address_help: 'Introduceți adresa la care este înregistrată firma dvs. Aceasta apare pe facturi.',
  },
  form: {
    legal_form: {
      label: 'Tip firmă',
      help: 'Un UG (haftungsbeschränkt) este aici un GmbH, un e.K. este persoană fizică autorizată. Pentru un OHG sau KG, vă rugăm să contactați asistența.',
      options: {
        sole_trader: 'Persoană fizică autorizată',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Denumire înregistrată a firmei',
      placeholder: 'Introduceți denumirea înregistrată a firmei',
      sole_trader_help: 'Lăsați necompletat dacă activați sub numele dvs. propriu',
    },
  },
  buttons: {
    next: 'Următorul',
  },
};
